import { Component, EventEmitter, Input, Optional, Output, Self } from '@angular/core';
import { ControlContainer, FormGroupDirective } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-button',
  imports: [ButtonModule],
  templateUrl: './button.html',
  styleUrl: './button.scss',
})
export class Button {
  @Input() label = 'Button';
  @Input() icon?: string;
  @Input() type: 'button' | 'submit' = 'button';
  @Input() severity:
    | 'primary'
    | 'secondary'
    | 'success'
    | 'info'
    | 'warn'
    | 'danger'
    | 'help'
    | 'contrast' = 'primary';
  @Input() outlined = false;
  @Input() text = false;
  @Input() rounded = false;
  @Input() raised = false;
  @Input() size: 'small' | 'large' = 'large';
  @Input() loading = false;
  @Input() disabled = false;
  @Input() customClass?: string;

  // Enable auto-validation
  @Input() validateForm = false;

  @Output() clicked = new EventEmitter<Event>();

  private sub?: Subscription;
  private formInvalid = false;

  constructor(@Optional() private formGroupDir: FormGroupDirective) {}

  ngOnInit(): void {
    if (this.validateForm && this.formGroupDir) {
      this.formInvalid = this.formGroupDir.form.invalid;

      // Watch form changes
      this.sub = this.formGroupDir.form.statusChanges.subscribe(() => {
        this.formInvalid = this.formGroupDir.form.invalid;
      });
    }
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  get isDisabled(): boolean {
    if (this.disabled || this.loading) return true;
    if (this.validateForm && this.type === 'submit') {
      return this.formInvalid;
    }
    return false;
  }

  onClick(event: Event) {
    if (!this.isDisabled) {
      this.clicked.emit(event);
    }
  }
}
